import React from 'react'

interface IProps {
  checked: boolean
  disabled?: boolean
  label: string
  onChange: (value: boolean) => void
}

const PreferenceToggle: React.FC<IProps> = ({
  checked,
  disabled,
  label,
  onChange
}) => (
  <label className={`flex flex-row items-center justify-between gap-4 ${disabled ? 'cursor-not-allowed' : 'cursor-pointer'}`}>
    <p className={`text-text-primary ${disabled ? 'opacity-50' : ''}`}>{label}</p>

    <span className='inline-flex items-center'>
      <input
        type='checkbox'
        checked={checked}
        disabled={disabled}
        className='sr-only peer'
        onChange={(event) => {
          onChange(event.target.checked)
        }}
      />

      <span
        className={`relative h-6 w-11 rounded-full bg-surface-track transition-colors peer-checked:bg-status-success-strong peer-focus-visible:outline peer-focus-visible:outline-2 peer-focus-visible:outline-border-focus peer-focus-visible:outline-offset-2 after:absolute after:start-[2px] after:top-[2px] after:h-5 after:w-5 after:rounded-full after:border after:border-border-default after:bg-surface-card after:transition-transform after:content-[''] peer-checked:after:translate-x-full peer-checked:after:border-status-success-strong ${disabled ? 'opacity-50' : ''}`}
      />
    </span>
  </label>
)

export default PreferenceToggle
